import { render, staticRenderFns } from "./SeebeckEffectViz.vue?vue&type=template&id=4af8e6bd&scoped=true"
import script from "./SeebeckEffectViz.vue?vue&type=script&lang=js"
export * from "./SeebeckEffectViz.vue?vue&type=script&lang=js"
import style0 from "./SeebeckEffectViz.vue?vue&type=style&index=0&id=4af8e6bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8e6bd",
  null
  
)

export default component.exports